import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.params = {
            offset: parseInt(this.el.getAttribute('data-scroll-offset')) || 0
        }
        this.el.addEventListener('click', () => {
            this.scrollToNextSection();
        });
    }

    scrollToNextSection() {
        // get current section
        let currentSection = this.el.closest('section');
        // get next section
        let nextSection = currentSection.nextElementSibling;
        if (nextSection.classList.contains('o-img-separator')) {
            nextSection = nextSection.nextElementSibling;
        }
        // scroll to next section
        window.locomotiveScroll.scrollTo(nextSection, this.params);
    }
}
